export default __webpack_public_path__ + "static/media/ICON4.794b54c1.svg";